export const TOGGLE_CONFIG = {
  small: {
    width: 24,
    height: 16,
    thumbSize: 16,
    activeLeft: 8,
    iconSize: 16,
    fontSize: 'xs',
  },
  medium: {
    width: 32,
    height: 20,
    thumbSize: 20,
    activeLeft: 12,
    iconSize: 20,
    fontSize: 's',
  },
} as const;
